<template>
  <div class="flex items-center justify-center w-16 h-16">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      class="w-24 h-36"
    >
      <path
        d="M4 21C4 19.1435 4.84285 17.363 6.34315 16.0503C7.84344 14.7375 9.87827 14 12 14C14.1217 14 16.1566 14.7375 17.6569 16.0503C19.1571 17.363 20 19.1435 20 21M9 15V15.5006C9 16.1634 9.31607 16.7992 9.87868 17.2679C10.4413 17.7367 11.2044 18 12 18C12.7956 18 13.5587 17.7367 14.1213 17.2679C14.6839 16.7992 15 16.1634 15 15.5006V15M8 7C8 8.06087 8.42143 9.07828 9.17157 9.82843C9.92172 10.5786 10.9391 11 12 11C13.0609 11 14.0783 10.5786 14.8284 9.82843C15.5786 9.07828 16 8.06087 16 7C16 5.93913 15.5786 4.92172 14.8284 4.17157C14.0783 3.42143 13.0609 3 12 3C10.9391 3 9.92172 3.42143 9.17157 4.17157C8.42143 4.92172 8 5.93913 8 7Z"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </div>
</template>
